export const MATERIAL_TYPES = [
  { key: 'paint', label: 'Pintura' },
  { key: 'varnish', label: 'Barniz' },
  { key: 'hot_melt', label: 'Hot Melt' },
  { key: 'cool_glue', label: 'Cool Glue' },
  { key: 'die_cut', label: 'Die Cut' },
  { key: 'boxes', label: 'Cajas' },
];

const text = (value) => String(value ?? '').trim().toUpperCase();
export const materialLabel = (type) => MATERIAL_TYPES.find(({ key }) => key === type)?.label || type;
export const normalizeMaterialTraceability = (materials = []) => materials.map((material) => ({
  work_order: text(material.work_order),
  material_type: material.material_type,
  reference: text(material.reference) || null,
  pallet_from: text(material.pallet_from) || null,
  pallet_to: text(material.pallet_to) || null,
}));

export const getMaterialWorkOrders = (rows = [], materials = []) => Array.from(new Set([
  ...rows.map((row) => text(row.work_order)),
  ...materials.map((material) => text(material.work_order)),
].filter(Boolean)));

export const getWorkOrderPallets = (rows, workOrder) => Array.from(new Set(
  rows.filter((row) => text(row.work_order) === text(workOrder)).map((row) => text(row.pallet_no)).filter(Boolean)
)).sort((a, b) => a.localeCompare(b, 'en', { numeric: true }));

export const materialPalletLabel = (material) => (
  material.pallet_from || material.pallet_to
    ? `${material.pallet_from || '?'} – ${material.pallet_to || '?'}` : 'Todas'
);

export const validateMaterialTraceability = (materials = [], rows = []) => {
  const workOrders = new Set(rows.map((row) => text(row.work_order)).filter(Boolean));
  return normalizeMaterialTraceability(materials).flatMap((material, index) => {
    const errors = [];
    if (!workOrders.has(material.work_order)) errors.push('La Work Order del material debe existir en la producción de este reporte.');
    if (!MATERIAL_TYPES.some(({ key }) => key === material.material_type)) errors.push('Selecciona un material válido.');
    if (!material.reference) errors.push('Completa el P.O. / lote del material antes de cerrar.');
    if ([material.work_order, material.reference, material.pallet_from, material.pallet_to].some((value) => value?.length > 255)) {
      errors.push('El P.O. / lote, Work Order y las tarimas admiten hasta 255 caracteres.');
    }
    if (material.pallet_from || material.pallet_to) {
      if (!material.pallet_from || !material.pallet_to) {
        errors.push('Completa la tarima inicial y final o selecciona Todas.');
      } else if (workOrders.has(material.work_order)) {
        const pallets = getWorkOrderPallets(rows, material.work_order);
        const start = pallets.indexOf(material.pallet_from);
        const end = pallets.indexOf(material.pallet_to);
        if (start < 0 || end < 0) errors.push('Las tarimas del material deben pertenecer a su Work Order en este reporte.');
        else if (start > end) errors.push('La tarima final debe ser igual o posterior a la inicial.');
      }
    }
    return errors.map((message) => ({ index, message }));
  });
};
